import { InternalParserError } from "./errors";

export function assert(condition: any, msg?: string): asserts condition {
  if (!condition) {
    throw new Error(msg);
  }
}

export function parseDate(value: string): Date {
  try {
    return new Date(value);
  } catch (error: unknown) {
    throw new InternalParserError(`Invalid date: ${value}`);
  }
}

// Parse code element
export function parseCode<T>(element: Element, parser: (code: string) => T): T {
  for (const child of element.children) {
    if (child.localName === "code") {
      return parser(child.textContent || "");
    }
  }

  throw new InternalParserError(`Missing <code> in <${element.localName}>`);
}
